<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card
            :loading="complaintRemoveReasonLoading"
        >
            <v-card-title>
                <template>
                    <h1 class="text-subtitle-1">
                        Proszę wybrać powód usunięcia reklamacji.
                    </h1>
                </template>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-select
                                v-model="reason"
                                :items="complaintRemoveReasons"
                                item-text="name"
                                outlined
                                no-data-text="Nie znaleziono powodów."
                                label="Powód usunięcia"
                                return-object
                                required
                                dense
                                :error-messages="reasonErrors"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Potwierdź"
                    :loading="actionLoading "
                    @click="onSave()"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'RemoveReasonDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        actionLoading: {
            type: Boolean
        },
        complaintData: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            complaintRemoveReasonLoading: false,
            complaintRemoveReasonsList: [],
            complaint: null,
            reason: null
        }
    },
    validations: {
        reason: {
            required: required
        }
    },
    computed: {
        complaintRemoveReasons() {
            return this.$store.state.complaints.complaints.complaintRemoveReasons || this.complaintRemoveReasonsList
        },
        reasonErrors() {
            const errors = []

            if (!this.$v.reason.$dirty) return errors
            !this.$v.reason.required && errors.push('Proszę wybrać powód.')

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.complaint = JSON.parse(JSON.stringify(this.complaintData))
                if (!this.complaintRemoveReasons.length) {
                    this.complaintRemoveReasonLoading = true
                    this.$store.dispatch('complaints/getComplaintRemoveReasons')
                        .then(({results}) => {
                            this.complaintRemoveReasonsList = results
                            this.complaintRemoveReasonLoading = false
                        })
                }
            } else {
                this.$v.$reset()
                setTimeout(() => {
                    this.complaint = {}
                    this.reason = null
                }, 500)
            }
        }
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }
            this.complaint.complaintRemoveReasonId = this.reason.id

            this.$emit('on-save', this.complaint)
            this.onClose()
        },
        onClose() {
            this.$emit('on-close')
        },
    }
}
</script>